module.exports = __webpack_public_path__ + "img/Drama.ede6b7a5.svg";